import { render, staticRenderFns } from "./ItemGolStrand.vue?vue&type=template&id=f759914a&scoped=true&"
import script from "./ItemGolStrand.vue?vue&type=script&lang=js&"
export * from "./ItemGolStrand.vue?vue&type=script&lang=js&"
import style0 from "./ItemGolStrand.vue?vue&type=style&index=0&id=f759914a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f759914a",
  null
  
)

export default component.exports